export const ChevronLeftIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path d='M16 4L8 11.5L16 19' stroke='currentColor' strokeWidth='2' />
    </svg>

);
